import OrdersPanel from "@/panel/OrdersPanel";

export default function MyOrdersPanel() {
  return (
    <div className="mx-auto max-w-screen-md pt-10">
      <OrdersPanel />
    </div>
  );
}
